import { CustomFormQuestion } from 'components/tools/CustomForm/types'
import { UseFormReturn } from 'react-hook-form'

type Params = {
  formMethods: UseFormReturn<any>
  questions: CustomFormQuestion[]
}

export default function setCalculoDeDiariasDoAGSUS(params: Params): CustomFormQuestion[] {
  const { questions } = params

  const visibleExcerpt2 = false
  const visibleExcerpt3 = false
  const visibleExcerpt4 = false

  const filteredQuestions = questions.filter((question) => {
    const questionAboutExcerpt = question.title?.includes('Trecho')
    const match = question.title?.match(/Trecho (\d+) -/)
    let number = null

    if (questionAboutExcerpt) {
      if (match) {
        number = parseInt(match[1], 10)
      }
    }

    if (number == 2 && !visibleExcerpt2) {
      return false
    }

    if (number == 3 && !visibleExcerpt3) {
      return false
    }

    if (number == 4 && !visibleExcerpt4) {
      return false
    }

    return true
  })

  return filteredQuestions
}
